<template>
  <div class="operation-area-inside" id="operation-area" :class="themeClass">
    <!-- 左边的操作 -->
    <div class="left-warp">
      <!--撤销-->
      <div class="left-warp-item revoke" @click="handleRetreat(0)" v-if="false">
        <i class="icon"></i>
        <span class="text">撤销</span>
      </div>
      <!--恢复-->
      <div class="split-line" v-if="false"></div>
      <div class="left-warp-item recovery" @click="handleAdvance" v-if="false">
        <i class="icon"></i>
        <span class="text">恢复</span>
      </div>
      <!--查找/替换-->
      <div class="split-line" v-if="false"></div>
      <div class="left-warp-item find-replace" @click="handleClick('first')">
        <i class="icon"></i>
        <span class="text">查找/替换</span>
      </div>
      <!--字体缩放-->
      <div class="split-line"></div>
      <el-popover
        trigger="click"
        placement="bottom"
        class="font-zoom-wrap"
        popper-class="font-zoom-wrap2"
      >
        <div class="font-zoom-inside">
          <el-slider
            :step="2"
            :min="12"
            :max="20"
            show-stops
            :show-tooltip="false"
            :marks="getfontSizeList"
            @input="hendleChange"
            v-model="value4"
          />
        </div>
        <div slot="reference" class="left-warp-item font-size">
          <i class="icon"></i>
          <span class="text">字体大小</span>
        </div>
      </el-popover>

      <!--添加术语-->
      <template v-if="getUrlTypeInfo !== 'school'">
        <div class="split-line"></div>
        <div class="left-warp-item add-terms" @click="handleClick('second')">
          <i class="icon"></i>
          <span class="text">添加术语</span>
        </div>
      </template>
    </div>
    <!-- 右边的操作 评分相关操作 -->
    <div class="right-warp">
      <el-button size="small" type="primary" @click="handlerpreservationEditor">
        保存</el-button
      >
    </div>
  </div>
</template>

<script>
import { eventUtil } from "@/components/editor/modules/eventUtil";
import { mapGetters, mapActions } from "vuex";
import { updateBatchSentence } from "@/services/editorApi";
// import editorMixin from "../editorArea/modules/editorContrast/common/mixin";
export default {
  name: "editor-operation",
  props: ["editorMode"],
  components: {},
  // mixins: [editorMixin],
  data() {
    return {
      fileinfo: {},
      timer: null,
      value4: 0,
      revokeData: new Map(), // 撤销数据
      recovery: new Map(), // 恢复数据
    };
  },

  computed: {
    ...mapGetters("editor", [
      "getFileInfo", // 文件信息
      "getUrlInfo", // url信息
      "getThemeInfo", // 编辑器当前主题
      "getProjectInfo", // 获取项目信息
      "getfontSizeList", // 文字大小
      "getscreenOptionsList", // 筛选文字设置选项
      "importOption", // 导出选项
      "getRevokeInfo", // 撤销的数据
      "getRecoveryInfo", // 恢复
      "getTempSentenceIdInfo", // 获取句子临时信息
    ]),
    getEditorRightShownInfo: function () {
      const self = this;
      let editorShownInfo = JSON.parse(
        JSON.stringify(self.$store.getters["editor/getEditorRightShownInfo"])
      );
      return editorShownInfo;
    },
    /**
     * @desc 是否开启机翻 渲染机翻图标
     * @return {boolean}
     */

    /**
     * @desc 是否渲染已评价图标
     * @return {boolean}
     */
    isShowEvaluated() {
      const { scoreStatus } = this.evaluationResults;
      if (scoreStatus !== 1) {
        return false;
      }
      const { identityType } = JSON.parse(localStorage.getItem("userInfo"));
      if (![1, 2, 3].includes(parseInt(identityType))) {
        return false;
      }
      return true;
    },

    /**
     * @desc 是否渲染退回重做及评分评价按钮
     * @return {boolean}
     */
    isShowScoreBtn() {
      // scoreStatus 未评价0 已评价1
      const { scoreStatus } = this.evaluationResults;
      if (scoreStatus) {
        return false;
      }
      const { toGrade } = this.getUrlInfo;
      if (!toGrade) {
        return false;
      }
      const { identityType } = JSON.parse(localStorage.getItem("userInfo"));
      if (![1, 3].includes(parseInt(identityType))) {
        return false;
      }
      return true;
    },

    /**
     * @desc 是否展示操作栏右侧评分图标按钮
     * @return {boolean}
     */
    isShowScoreRight() {
      if (this.getUrlTypeInfo !== "school") {
        return false;
      }
      const { finish } = this.getFileTaskInfo;
      if (parseInt(finish) !== 1) {
        return false;
      }
      return true;
    },

    //获取url中的type信息
    getUrlTypeInfo() {
      const { type } = this.getUrlInfo;
      if (type) {
        return type;
      }
      return "";
    },

    //获取主题
    themeClass() {
      const theme = this.getThemeInfo;
      return `operation-area-inside-${theme}`;
    },

    /**
     * @desc 是否展示退回任务按钮
     * @return {boolean}
     */
    isShowBankTask() {
      const { finish, taskType } = this.getUrlInfo;
      if (this.getUrlTypeInfo === "task" && [2, 3].includes(taskType)) {
        // 我的任务进入
        return true;
      } else if (this.getUrlTypeInfo === "project" && finish === 1) {
        // 项目经理从项目进入
        return true;
      }
      return false;
    },

    /**
     * @desc 是否展示验收按钮
     * @return
     */
    isShowAccepted() {
      const { finish } = this.getUrlInfo;
      if (this.getUrlTypeInfo === "project" && finish === 1) {
        // 项目经理从项目进入
        return true;
      }
      return false;
    },

    /**
     * @desc 获取翻译详情修改记录的数据
     * @return
     */
    getEditordatarevokeList() {
      return this.$store.getters["editor/getEditordatarevokeList"];
    },
  },
  watch: {
    editorMode(val) {
      this.mark_value = val;
    },
    getFileTaskInfo: {
      handler(newVal, oldVal) {
        if (newVal && !Object.keys(oldVal).length) {
          const { finish } = newVal;
          if (this.getUrlTypeInfo === "school" && parseInt(finish) === 1) {
            // 获取评价状态
            const { taskId } = this.getUrlInfo;
            this.$store.dispatch("editor/updateEvaluationResults", { taskId });
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    // 文字大小缓存
    this.setEditorFontSize();
    this.queryRouteInof =
      JSON.parse(this.$Base64.decode(this.$route.query.key)) || {};
    this.$nextTick(() => {
      // 键盘事件监听
      document.addEventListener("keydown", this.handleKeydown);
    });
  },

  destroyed() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    ...mapActions("editor", [
      "setEditordataList", // 暂存修改的数据
      "deleteEditordataList", // 撤销存储修改数据列表（尾删）
    ]),
    //保存修改
    async handlerpreservationEditor() {
      const getEditordataList = this.$store.getters["editor/getEditordataList"];
      let updateSingleSentenceReqVoList = [...getEditordataList.values()];
      if (updateSingleSentenceReqVoList.length === 0) {
        this.$message.closeAll();
        this.$message.warning("暂无修改数据!");
        return;
      }
      let params = {
        fileId: updateSingleSentenceReqVoList[0].fileId,
        updateSingleSentenceReqVoList,
      };
      const { success } = await updateBatchSentence(params);
      if (success) {
        this.$message.closeAll();
        this.$message.success("修改内容成功");
        this.$store.dispatch("editor/setEditordataList", {
          operation: "clear",
        });
      }
    },
    handleRedoClose() {
      this.redoVisible = false;
    },
    handleRedoConfirm() {
      this.redoVisible = false;
    },
    handleScoreClose() {
      this.scoreVisible = false;
    },
    handleScoreConfirm() {
      this.scoreVisible = false;
    },

    // 退回任务
    async handleBankTask() {
      if (this.getUrlTypeInfo === "project") {
        // 项目经理从项目进入
      } else if (this.getUrlTypeInfo === "task") {
        this.bankTaskVisible = true;
      }
    },
    handleBankTaskClose() {
      this.bankTaskVisible = false;
    },
    handleBankTaskConfirm() {
      this.bankTaskVisible = false;
    },

    handleAcceptedClose() {
      this.acceptedVisible = false;
    },
    handleAcceptedConfirm() {
      this.acceptedVisible = false;
    },

    /**
     * @desc 预览模式切换
     */
    handleChangeViewMode(item) {
      let { name, id, title } = item;
      let fileSuffixList = ["xlsx", "xls"];
      const { fileSuffix } = this.queryRouteInof;
      if (
        id === 2 &&
        title === "上下对照" &&
        fileSuffixList.includes(fileSuffix)
      ) {
        name = "editorXls";
      }
      if (name !== "newEditor") {
        let taskContentListParams =
          this.$store.getters["editor/getTaskContentListParams"];
        if (
          taskContentListParams.hasComment ||
          taskContentListParams.transStatus ||
          taskContentListParams.hasRepeatLock
        ) {
          taskContentListParams.hasComment = "";
          taskContentListParams.transStatus = "";
          taskContentListParams.hasRepeatLock = "";
        }
        Reflect.set(taskContentListParams, "startSort", 1);
        if (this.getUrlTypeInfo == "project") {
          this.$store.dispatch("editor/getFileContent", taskContentListParams);
        } else {
          this.$store.dispatch("editor/getTaskContent", taskContentListParams);
        }
      }
      this.$store.commit("editor/update_current_view_mode", item);
      this.$router.push({
        name,
        query: {
          key: this.$Base64.encode(JSON.stringify(this.queryRouteInof)),
          importOption: this.$Base64.encode(JSON.stringify(this.importOption)),
        },
      });
    },

    //键盘事件
    handleKeydown(e) {
      if (e.ctrlKey && e.keyCode === 70) {
        eventUtil.preventDefault(e);
        this.handleClick("first");
      } else if (e.altKey && e.keyCode === 84) {
        //添加术语 alt + t
        console.log("Alt+T");
        eventUtil.preventDefault(e);
        let urlTypeInfo = this.getUrlTypeInfo;
        if (urlTypeInfo !== "school") {
          this.handleClick("second");
        }
      }
    },

    // 撤销revokeInfo
    handleRetreat() {
      this.deleteEditordataList();

      // if (this.getEditordatarevokeList.length === 0) {
      //   this.$message.closeAll();
      //   this.$message.warning('暂无撤销数据')
      //   return
      // }
      // let getEditorList = this.$store.getters['editor/getEditordataList'];
      // getEditorList.forEach(item => {
      //   if (item.sentId === this.getEditordatarevokeList[this.getEditordatarevokeList.length - 1].sentId) {
      //     item = this.getEditordatarevokeList[this.getEditordatarevokeList.length - 1];
      //     this.getEditordatarevokeList.pop();
      //   }
      // })
      // this.$store.dispatch('editor/setEditordataList', getEditorList)
      // console.log(getEditorList)
      // this.getEditordatarevokeList.forEach(key => {
      // console.log(key)
      // if(getEditorList.find(key.sentId) )
      // if (this.getEditorList[this.getEditorList.length - this.setindex] && key.id === this.getEditorList[this.getEditorList.length - this.setindex].sentId) {
      //   let oldEditor = JSON.parse(key.tagTargetSent).fragments[0].atoms[0].data
      //   this.getEditorList.forEach(item => {
      //     if (item.sentId === key.id) {
      //       item.targetTagFragmentVo.atoms[0].data = oldEditor
      //     }
      //   })
      //   // document.execCommand('Undo')
      //   this.$store.dispatch('editor/setEditordataList', this.getEditorList)
      //   this.setindex++;
      // }
      // })
    },
    // 恢复recoveryInfo
    handleAdvance() {
      if (
        !(
          this.getEditorList[this.getEditorList.length - this.setindex] &&
          this.getEditorList[this.getEditorList.length - this.setindex].sentId
        )
      ) {
        this.$message.closeAll();
        this.$message.warning("暂无撤销数据");
        return;
      }
      let getTaskContentList = this.$store.getters["editor/getTaskContentList"];
      getTaskContentList.transSentRespVoList.forEach((key) => {
        if (
          this.getEditorList[this.getEditorList.length - this.setindex] &&
          key.id ===
            this.getEditorList[this.getEditorList.length - this.setindex].sentId
        ) {
          let oldEditor = JSON.parse(key.tagTargetSent).fragments[0].atoms[0]
            .data;
          this.getEditorList.forEach((item) => {
            if (item.sentId === key.id) {
              item.targetTagFragmentVo.atoms[0].data = oldEditor;
            }
          });
          document.execCommand("Undo");
          this.$store.dispatch("editor/setEditordataList", this.getEditorList);
          this.setindex++;
        }
      });
      // document.execCommand("");
    },
    //向下合并
    handleDonMerge() {
      if (this.getEditorModeInfo === "mark") {
        this.$message.closeAll();
        this.$message.warning("修订模式下,不能进行向下合并操作");
        return false;
      }
      let fileId = null;
      if (this.getUrlTypeInfo === "project") {
        const { finish, id } = this.getFileInfo;
        if (finish == 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行向下合并操作");
          return false;
        }
        fileId = id;
      } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
        const { finish } = this.getFileTaskInfo;
        if (finish == 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行向下合并操作");
          return false;
        }
        fileId = this.getFileTaskInfo.fileId;
      }
      // let getSourceeditStatus = self.$store.getters["editor/getSourceeditStatus"];
      // if (getSourceeditStatus === true) {
      if (this.getTempSentenceIdInfo.type === "source") {
        //获取当前句的的dom--获取句子的父级--获取当前句子兄弟
        let currentId = this.getTempSentenceIdInfo.item.id;
        let dom = document.getElementById(`source-${currentId}`);
        let parentNodeDom = dom.parentNode.parentNode;
        let parentNodeNextDom = parentNodeDom.nextSibling;
        let nextId = parentNodeNextDom.getAttribute("infoid");
        let params = Object();
        Reflect.set(params, "sourceSentId", currentId);
        Reflect.set(params, "targetSentId", parseInt(nextId));
        Reflect.set(params, "transFileId", fileId);
        this.$store.dispatch("editor/mergeFragment", params).then(() => {
          this.$store.dispatch("editor/recordCursorPosition", {});
          this.$store.dispatch("editor/setTempSentenceId", {});
        });
      } else {
        this.$message({
          message: "请先将光标定位到原文",
          type: "warning",
        });
      }
      // } else {
      //   self.$message.closeAll();
      //   self.$message({
      //     message: '请先点击编辑原文，再进行合并操作',
      //     type: 'warning'
      //   });
      // }
    },

    //拆分句子
    handleSplitFrangment() {
      if (this.getEditorModeInfo === "mark") {
        this.$message.closeAll();
        this.$message.warning("修订模式下,不能进行拆分操作");
        return false;
      }
      let fileId = null;
      if (this.getUrlTypeInfo === "project") {
        const { finish, id } = this.getFileInfo;
        if (finish == 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行拆分句子操作");
          return false;
        }
        fileId = id;
      } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
        const { finish } = this.getFileTaskInfo;
        if (finish == 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行拆分句子操作");
          return false;
        }
        fileId = this.getFileTaskInfo.fileId;
      }
      // let getSourceeditStatus = this.$store.getters["editor/getSourceeditStatus"];
      // if (getSourceeditStatus === true) {
      let cursorPositionInfo =
        this.$store.getters["editor/getCursorPositionInfo"];
      if (
        this.getTempSentenceIdInfo.type === "source" &&
        !!cursorPositionInfo.length
      ) {
        let params = Object();
        cursorPositionInfo.pop();
        Reflect.set(params, "sentId", this.getTempSentenceIdInfo.item.id);
        Reflect.set(params, "transFileId", fileId);
        Reflect.set(params, "transFileSentList", cursorPositionInfo);

        this.$store.dispatch("editor/splitFragment", params).finally(() => {
          this.$store.dispatch("editor/recordCursorPosition", {});
          this.$store.dispatch("editor/setTempSentenceId", {});
        });
      } else {
        this.$message({
          message: "请先将光标定位到原文",
          type: "warning",
        });
      }
      // } else {
      //   self.$message.closeAll();
      //   self.$message({
      //     message: '请先点击编辑原文，再进行拆分操作',
      //     type: 'warning'
      //   });
      // }
    },

    //缓存取页面设置字号设置到vuex中
    setEditorFontSize() {
      let editorFontSize = parseInt(
        localStorage.getItem("editorFontSize") || 12
      );
      this.value4 = editorFontSize;
      this.$store.dispatch("editor/setEditorFontSizeInfo", editorFontSize);
    },

    //改变编辑模式
    handleEditorModeChange(value) {
      console.log(value);
      this.$emit("setEditorMode", value);
      let params = {
        column: "",
        keyword: "",
      };
      this.$store.dispatch("editor/setOerationSignInfo", params);
    },

    //确定点击标识-右侧显示具体的内容
    handleClick(value) {
      let flag = false;
      if (value === "second") {
        //如果是点击是术语库的就进来
        if (this.getUrlTypeInfo === "project") {
          //是否被拆分 0/1 - (未分配/分配) - (能编辑/编辑)
          const { finish } = this.getFileInfo;
          if (finish === 1 && value === "second") {
            this.$message.closeAll();
            this.$message.warning("任务已提交,不能进行添加术语操作");
            return false;
          }
          let isSplit = !parseInt(this.getFileInfo.isSplit);
          flag = !isSplit;
          // , 'school' ['task'].includes(this.getUrlTypeInfo)
        } else if (this.getUrlTypeInfo === "task") {
          const { finish } = this.getFileTaskInfo;
          if (finish === 1 && value === "second") {
            this.$message.closeAll();
            this.$message.warning("任务已提交,不能进行添加术语操作");
            return false;
          }
          let isFinish = parseInt(finish) === 1;
          flag = isFinish;
        }
        if (flag) {
          this.$message.closeAll();
          this.$message({
            message: "锁定句子不能进行添加术语",
            type: "warning",
          });
          return;
        }
      }
      let params = {};
        if (value == "second") {
          params = {
            column: value,
            sourceKeyword: this.getEditorRightShownInfo.sourceKeyword,
            targetKeyword: this.getEditorRightShownInfo.targetKeyword,
          };
        } else {
          params = {
            column: value,
            source: "",
            target: "",
          };
        }
        this.$store.dispatch("editor/setOerationSignInfo", params);
        this.$store.dispatch("editor/setEditorRightActiveName", "first");
    },

    //改变文字的大小
    hendleChange(value) {
      localStorage.setItem("editorFontSize", parseInt(value));
      this.value4 = parseInt(value);
      this.$store.dispatch("editor/setEditorFontSizeInfo", parseInt(value));
    },

    //改变锁定状态筛选
    handleChange(value, type) {
      let data = {};
      console.log(value);
      this.filterType = type;
      Reflect.set(data, "type", type);
      Reflect.set(data, "value", value);
      this.$store.dispatch("editor/changeFilter", data);
    },

    //重新机翻
    handleAfreshTranslate() {
      let fileId = null;
      if (this.getUrlTypeInfo === "project") {
        const { finish, id } = this.getFileInfo;
        if (finish === 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行重新翻译操作");
          return false;
        }
        fileId = id;
      } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
        const { finish } = this.getFileTaskInfo;
        if (finish === 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行重新翻译操作");
          return false;
        }
        fileId = this.getFileTaskInfo.fileId;
      }
      if (this.getEditorModeInfo === "mark") {
        this.$message.closeAll();
        return this.$message.warning("修订模式下，不能进行重新翻译操作");
      }
      let params = Object();
      if (
        Reflect.has(this.getTempSentenceIdInfo, "type") &&
        this.getTempSentenceIdInfo.type === "source"
      ) {
        Reflect.set(params, "sid", this.getTempSentenceIdInfo.item.id);
        Reflect.set(params, "fileId", fileId);
        this.$store.dispatch("editor/afreshTranslate", params);
      } else {
        this.$message({
          message: "请光标先获取原文",
          type: "warning",
        });
      }
    },
    //编辑原文
    handlesource() {
      if (!this.getEleStatus) {
        this.$message.closeAll();
        this.$message.warning("当前句子包含检索高亮词,不能进行编辑原文操作");
        return false;
      }
      if (this.getUrlTypeInfo === "project") {
        const { finish } = this.getFileInfo;
        if (finish === 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行编辑原文操作");
          return false;
        }
      } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
        const { finish } = this.getFileTaskInfo;
        if (finish === 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行编辑原文操作");
          return false;
        }
      }
      this.$store.dispatch("editor/setSourceeditEditorisSourceedit", true);
    },
    //复制到译文
    handleCopyToTarget() {
      const self = this;
      if (
        Reflect.has(this.getTempSentenceIdInfo, "type") &&
        this.getTempSentenceIdInfo.type === "source"
      ) {
        if (this.getTempSentenceIdInfo.item) {
          let item = this.getTempSentenceIdInfo.item;
          const sourceTag = JSON.parse(item.tagSourceSent);
          if (
            !!sourceTag &&
            !!sourceTag.fragments &&
            !!sourceTag.fragments.length
          ) {
            let sourceTag2 = sourceTag.fragments[0].atoms;
            let targetTemp = Object();
            let fileId = null;
            if (this.getUrlTypeInfo === "project") {
              const { finish, id } = this.getFileInfo;
              if (finish === 1) {
                self.$message.closeAll();
                self.$message.warning("任务已提交,不能进行复制到译文操作");
                return false;
              }
              fileId = id;
            } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
              const { finish } = this.getFileTaskInfo;
              if (finish === 1) {
                self.$message.closeAll();
                self.$message.warning("任务已提交,不能进行复制到译文操作");
                return false;
              }
              fileId = this.getFileTaskInfo.fileId;
            }
            Reflect.set(targetTemp, "sort", 0);
            Reflect.set(targetTemp, "text", null);
            Reflect.set(targetTemp, "type", null);
            Reflect.set(targetTemp, "atoms", sourceTag2);
            let params = {};
            Reflect.set(params, "constTime", 0);
            Reflect.set(params, "taskId", null);
            Reflect.set(params, "taskType", null);
            Reflect.set(params, "isSaveVersion", null);
            Reflect.set(params, "sentId", item.id);
            Reflect.set(params, "content", item.sourceSent);
            Reflect.set(params, "status", item.status);
            Reflect.set(params, "fileId", fileId);
            Reflect.set(params, "sourceTagFragmentVo", null);
            Reflect.set(params, "targetTagFragmentVo", targetTemp);
            this.$store.dispatch("editor/updateTargetInfo", {
              params: params,
              type: 1,
            });
          }
        }
      } else {
        self.$message({
          message: "请光标先获取原文",
          type: "warning",
        });
      }
    },

    //自动填充
    handleAutoFillTag() {
      let params = {};
      let fileId = null;
      if (this.getUrlTypeInfo === "project") {
        const { finish, id } = this.getFileInfo;
        if (finish === 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行自动填充操作");
          return false;
        }
        fileId = id;
      } else if (["task", "school"].includes(this.getUrlTypeInfo)) {
        const { finish } = this.getFileTaskInfo;
        if (finish === 1) {
          this.$message.closeAll();
          this.$message.warning("任务已提交,不能进行自动填充操作");
          return false;
        }
        fileId = this.getFileTaskInfo.fileId;
        if (this.getUrlTypeInfo === "school") {
          const { id: taskId } = this.getFileTaskInfo;
          Reflect.set(params, "taskId", taskId);
          Reflect.set(params, "taskType", this.getUrlTypeInfo);
        }
      }
      Reflect.set(params, "fileId", fileId);
      this.$store.dispatch("editor/autoFillTag", params);
    },
  },
};
</script>
<style lang="less" scoped>
@import "./assets/style.less";
</style>
<style lang="less">
@import "assets/global.less";
</style>
